import { action, createRequestTypes } from '../base';

export const integrationActionTypes = {
  GET_INTEGRATIONS: createRequestTypes('GET_INTEGRATIONS'),
};

/**
 * @param payload
 * @param linkedDaData
 * @param createDaTallyLinkSuccess
 * @param callback
 * @param orgId
 */
class IntegrationActions {
    /**
     *
     * @param {*} orgId
     * @param {*} callback
     * @returns
     */
    getIntegrations = (orgId, callback) => action(integrationActionTypes.GET_INTEGRATIONS.REQUEST, {
      orgId, callback,
    })

    /**
     *
     * @param {*} getIntegrationsLoading
     * @return
     */
    getIntegrationsLoading = (getIntegrationsLoading) => action(integrationActionTypes.GET_INTEGRATIONS.LOADING, {
      getIntegrationsLoading,
    })

     /**
      * @return
      * @param linkedDaData
      */
     getIntegrationsSuccess = (integrations) => action(integrationActionTypes.GET_INTEGRATIONS.SUCCESS, {
       integrations,
     })
}

export default new IntegrationActions();
